module.exports = __webpack_public_path__ + "static/media/chair1right.e5edd15a.png";